import { css } from '@emotion/react';
import { useHover } from '@react-aria/interactions';
import * as React from 'react';

import { Recipient } from 'api/api';

import { colors } from '~src/theme/colors';
import { useAriaGridCell } from '~src/ui/aria-grid';
import { ListState } from '~src/ui/list-state';
import { RadioInputMock } from '~src/ui/radio-input';

import { AddressCardUI } from './address-card';

interface AddressListItemProps {
  address: Recipient;
  listState: ListState<Recipient>;
  handleClick: () => void;
}

export const AddressListItem: React.FC<AddressListItemProps> = ({
  address,
  listState,
  handleClick,
}) => {
  const ref = React.useRef(null);
  const { hoverProps, isHovered } = useHover({});

  const { cellProps, isSelected } = useAriaGridCell({
    itemKey: address.id || '',
    listState,
    ref,
    enableAutoSelect: true,
  });

  return (
    <div
      key={address.id}
      className="focus-visible-outline"
      css={styles.wrapper(isSelected)}
      ref={ref}
      {...hoverProps}
      {...cellProps}
    >
      <RadioInputMock
        checked={isSelected}
        showDarkerBorder={!isSelected && isHovered}
        title="Address"
      />
      <AddressCardUI
        disableKeyboard={!isSelected}
        handleClick={handleClick}
        address={address}
        boldenFirstLine
      />
    </div>
  );
};

const styles = {
  wrapper: (selected: boolean) =>
    css({
      display: 'grid',
      gridTemplateColumns: '20px auto',
      columnGap: '10px',
      padding: '12px 0px',
      borderBottom: `1px solid ${colors.neutral91}`,
      cursor: selected ? 'initial' : 'pointer',
    }),
};
